<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view></router-view>
    </transition>
    <div class="foot">
      <ul>
        <li><img src="../static/logo.png" alt=""></li>
        <li>梯云物联科技有限公司</li>
        <li style="float:right; "><span style="display: none;">www.sztyiot.com</span></li>
      </ul>
    </div>
  </div>
</template>

<script>
import GLOBAL from '@/api/global_variable'
export default {
  name: 'App',
  data () {
    return {
      cityName: '',
      requestNum: 0,
      transitionName: ''
    }
  },
  mounted () {
    // 每30秒刷新数据
    var that = this
    const cityName = sessionStorage.getItem('cityName')
    this.cityName = cityName
    if (GLOBAL.isLogin()) {
      setInterval(function () {
        ++that.requestNum
        console.log('getData:' + that.requestNum)
        // that.$ajax.get('http://open.tywliot.com/datacenter/GetStatisticsData?keytype=' + GLOBAL.getKeyType()).then(res => {
        //   GLOBAL.viewData = res.data.Data
        // }).catch(err => {
        //   console.log(err)
        // })
      }, 30000)
    }
  },
  watch: {// 使用watch 监听$router的变化
    $route (to, from) {
      // 如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        // 设置动画名称 slide-left
        this.transitionName = ''
      } else {
        this.transitionName = ''
      }
    }
  }
}
</script>

<style>
html {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}
body {
  width: 100%;
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
.foot {
  width: 100%;
  height: 40px;
  background: #0b133f;
}

.foot > ul {
  width: 98%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.foot > ul > li {
  float: left;
  list-style: none;
  height: 100%;
  color: #263a64;
  font-size: 14px;
  line-height: 40px;
  margin-left: 10px;
}
.foot > ul > li:first-child {
  margin-left: 2px;
}
.foot > ul > li > img {
  width: 28px;
  height: 18px;
  vertical-align: middle;
}
.foot > ul > li > span {
  width: auto;
  height: 100%;
}
.foot > ul > li > span:first-child {
  font-size: 20px;
  font-weight: bold;
  line-height: 30px;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.el-scrollbar__wrap {
  overflow-x: hidden;
}

/*设置xx条/页的框的颜色*/
.el-select .el-input.is-focus .el-input__inner,
.el-pagination__sizes .el-input .el-input__inner:hover,
.el-select .el-input__inner:focus {
  border: 0;
}

.el-input__inner {
  border: 0;
  background: transparent;
}
.el-form-item__content {
  height: 47px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue